import React, { forwardRef, MutableRefObject } from 'react';
import InputBase from '../InputBase';
import { IInputProps } from '../InputBase/InputBase';

import './InputInitial.css';

const InputInitial = forwardRef(
	(
		{
			className = '',
			value = '',
			setValue = () => {},
			label,
			...rest
		}: IInputProps,
		ref: any,
	) => {
		const formatInitial = (initial) => {
			return initial.replace(/[^a-zA-Z]/g, '').toUpperCase();
		};
		const isInitialValid = (val) => {
			if (val.match(/[a-zA-Z]/g) === null) {
				return false;
			}
			return true;
		};

		return (
			<InputBase
				label={label}
				type='text'
				className={`InputInitial ${className}`}
				ref={ref}
				formatValue={formatInitial}
				isValid={isInitialValid}
				setValue={(initial) => {
					setValue(formatInitial(initial));
				}}
				value={value}
				id='CP_initials'
				{...rest}
			/>
		);
	},
);

InputInitial.displayName = 'InputInitial';

export default InputInitial;
